import { defaultTheme, discoTheme, smaTheme, lichtblickTheme } from "./themes";

export type ThemeName = "sma" | "disco" | "default" | "lichtblick";

export enum ThemeValues {
  SMA = "sma",
  default = "default",
  lichtblick = "lichtblick",
}

export const THEMES = {
  sma: smaTheme,
  disco: discoTheme,
  default: defaultTheme,
  lichtblick: lichtblickTheme,
};
